import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
  max-width: 1400px;
  margin: 0;
`;

export const Header = styled.div`
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
`;

export const InfoSection = styled.div`
  background: ${(props) => props.theme.palette[100]};
  border: 1px solid ${(props) => props.theme.palette[300]};
  border-radius: 8px;
  padding: 24px;
`;

export const SectionTitle = styled.div`
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${(props) => props.theme.palette[300]};
`;

export const InfoRow = styled.div`
  display: flex;
  padding: 8px 0;
  gap: 12px;

  &:not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.palette[200]};
  }
`;

export const InfoLabel = styled.div`
  min-width: 150px;
  font-weight: 500;
  color: ${(props) => props.theme.palette[700]};
`;

export const InfoValue = styled.div`
  flex: 1;
  color: ${(props) => props.theme.palette[900]};
  word-break: break-word;
`;

export const RecordsSection = styled.div`
  background: ${(props) => props.theme.palette[100]};
  border: 1px solid ${(props) => props.theme.palette[300]};
  border-radius: 8px;
  padding: 24px;
`;

export const RecordsetsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RecordsetItem = styled.div<{ isEditing?: boolean }>`
  background: ${(props) => props.theme.palette[10]};
  border: 1px solid ${(props) => (props.isEditing ? props.theme.primary[400] : props.theme.palette[300])};
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${(props) => props.theme.palette[400]};
  }
`;

export const RecordsetHeader = styled.div`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${(props) => props.theme.palette[50]};
  border-bottom: 1px solid ${(props) => props.theme.palette[300]};
`;

export const RecordsetBody = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RecordField = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const RecordRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-end;
`;

export const RecordActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid ${(props) => props.theme.palette[300]};
`;

export const AddRecordButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: ${(props) => props.theme.palette[200]};
  border: 1px dashed ${(props) => props.theme.palette[400]};
  border-radius: 4px;
  color: ${(props) => props.theme.palette[800]};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => props.theme.palette[300]};
    border-color: ${(props) => props.theme.palette[500]};
  }
`;

export const ReadOnlyRecordset = styled.div`
  padding: 12px 16px;
  background: ${(props) => props.theme.palette[100]};
  border: 1px solid ${(props) => props.theme.palette[300]};
  border-radius: 4px;
  margin-bottom: 8px;
  color: ${(props) => props.theme.palette[700]};
`;

export const FloatingAddButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  margin-top: 20px;
  background: ${(props) => props.theme.primary[600]};
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  &:hover {
    background: ${(props) => props.theme.primary[700]};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
`;
